import React from "react";
import { Card, Button, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { Height } from "@mui/icons-material";
const { Meta } = Card;
const gridStyle = {
  width: "25%",
  textAlign: "center",
};
const App = () => (
  <Card
    title={
      <Breadcrumb
        items={[
          {
            title: "Beranda",
          },
          {
            title: "Unduh Data",
          },
        ]}
      />
    }
    styles={{
      body: {
        maxHeight: "500px",

        overflow: "auto",
      },
    }}
  >
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="RBI per Wilayah Sumatra"
            src={process.env.PUBLIC_URL + "/static/images/unduh_rbi_sumatra.png"}
          />
        }
        actions={[
          <Link target="_blank" to="/unduh/rbi-sumatra">
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="RBI per Wilayah Sumatra"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="Data Analisis Banjir Sumatra Tahun 2025"
            src={process.env.PUBLIC_URL + "/static/images/unduh_banjir_sumatra.png"}
          />
        }
        actions={[
          <Link target="_blank" to="/unduh/banjir-sumatra">
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="Data Analisis Banjir Sumatra Tahun 2025"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="example"
            src={process.env.PUBLIC_URL + "/static/images/unduh_ksp.png"}
          />
        }
        actions={[
          <Link target="_blank" to="https://onemap.big.go.id">
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="Data KSP"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="batnas"
            src={process.env.PUBLIC_URL + "/static/images/unduh_batnas.png"}
          />
        }
        style={{
          height: "100%",
        }}
        actions={[
          <Link to="/unduh/batnas">
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="Data Batnas"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="demnas"
            src={process.env.PUBLIC_URL + "/static/images/unduh_demnas.png"}
          />
        }
        actions={[
          <Link to="/unduh/demnas">
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="Data Demnas"
      ></Card>
    </Card.Grid>

    <Card.Grid hoverable style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="RBI Per Wilayah"
            src={
              process.env.PUBLIC_URL + "/static/images/unduh_rbi_wilayah.png"
            }
          />
        }
        actions={[
          <Link to="/unduh/rbi-wilayah">
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="Data RBI per Wilayah"
      ></Card>
    </Card.Grid>

    <Card.Grid hoverable style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="Batas Wilayah"
            src={
              process.env.PUBLIC_URL + "/static/images/unduh_batas_wilayah.png"
            }
          />
        }
        actions={[
          <Link
            target="_blank"
            to="https://geoservices.big.go.id/portal/apps/webappviewer/index.html?id=cb58db080712468cb4bfd408dbde3d70"
          >
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="Data Batas Wilayah"
      ></Card>
    </Card.Grid>
    <Card.Grid hoverable style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="RBI Cetak 25K"
            src={
              process.env.PUBLIC_URL + "/static/images/unduh_rbi_cetak_25k.png"
            }
          />
        }
        actions={[
          <Link to="/unduh/rbi-cetak-25k">
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="Data RBI Cetak 25K"
      ></Card>
    </Card.Grid>

    <Card.Grid hoverable style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="RBI Cetak 50K"
            src={
              process.env.PUBLIC_URL + "/static/images/unduh_rbi_cetak_50k.png"
            }
          />
        }
        actions={[
          <Link to="/unduh/rbi-cetak-50k">
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="Data RBI Cetak 50K"
      ></Card>
    </Card.Grid>

    <Card.Grid hoverable style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="RBI Cetak 250K"
            src={
              process.env.PUBLIC_URL + "/static/images/unduh_rbi_cetak_250k.png"
            }
          />
        }
        actions={[
          <Link to="/unduh/rbi-cetak-250k">
            <Button type="primary">Unduh Data</Button>
          </Link>,
        ]}
        title="Data RBI Cetak 250K"
      ></Card>
    </Card.Grid>
  </Card>
);
export default App;
